import CustomModal from 'components/Common/CustomModal'
import React, { useRef, useState } from 'react'
import { Spinner } from 'reactstrap'

import { ReactComponent as Upload } from "../../assets/img/uploadfile.svg"
import api from 'api'
import { toast } from 'react-toastify'
import VariantEditor, { validateVariants, variantsForSubmit } from './VariantEditor'

const inputStyle = {
    backgroundColor: "#F3F3F3",
    border: "none",
    borderRadius: "8px",
    fontFamily: "Outfit",
    width: "100%",
    padding: "12px 17px",
    minHeight: '44px',
};

const labelStyle = {
    marginTop: '10px',
    fontWeight: 600,
    fontSize: '16px',
    fontFamily: "Outfit",
    color: '#1C1C1C',
};

const AddProduct = ({ handleModal, brandId, getBrandProducts }) => {
    const [file, setFile] = useState();
    const [dragging, setDragging] = useState(false);
    const [saving, setSaving] = useState(false);
    const uploadref = useRef(null)
    const [data, setData] = useState({
        name: '',
        pointsRequired: '',
        stockLevel: '',
        description: ''
    })
    const [hasVariants, setHasVariants] = useState(false)
    const [variants, setVariants] = useState([])
    const [variantsError, setVariantsError] = useState(null)

    const handleAddProduct = () => {
        if (saving) return;
        if (hasVariants) {
            const result = validateVariants(variants)
            if (!result.valid) {
                setVariantsError(result.message)
                return
            }
            setVariantsError(null)
        }

        const formdata = new FormData()
        formdata.append('productName', data.name)
        if (file) formdata.append('product_img', file)
        formdata.append('pointsRequired', data.pointsRequired)
        formdata.append('description', data.description)
        formdata.append('brandId', brandId)
        formdata.append('hasVariants', String(hasVariants))
        if (hasVariants) {
            formdata.append('variants', JSON.stringify(variantsForSubmit(variants)))
        } else {
            formdata.append('stockLevel', data.stockLevel)
        }
        setSaving(true)
        api('post', `/brandproducts`, formdata).then((res) => {
            toast.success(res.message)
            handleModal()
            getBrandProducts()
        }).catch((err) => {
            const code = err?.response?.data?.code
            const msg = err?.response?.data?.message
            if (hasVariants && code && (code.startsWith('VARIANT') || code === 'INVALID_VARIANTS')) {
                setVariantsError(msg || 'Please fix the variants below.')
            }
            console.log(err)
        }).finally(() => {
            setSaving(false)
        })
    }

    const handleChange = (e) => {
        setData((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }

    const handleFileChange = (event) => {
        if (event.target.files.length) {
            setFile(event.target.files[0]);
        } else {
            setFile();
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragging(true);
    };
    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragging(false);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragging(false);
        if (e.dataTransfer.files && e.dataTransfer.files.length) {
            const droppedFile = e.dataTransfer.files[0];
            if (droppedFile.type.startsWith('image/')) {
                setFile(droppedFile);
            }
        }
    };

    const customFooter = (
        <>
            <button className='vs-btn-cancel' onClick={handleModal} disabled={saving}>
                Cancel
            </button>
            <button
                disabled={saving}
                className={`vs-btn-save ${saving ? 'disabled' : ''}`}
                onClick={handleAddProduct}
                style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}
            >
                {saving ? (<><Spinner size='sm' /> Saving…</>) : 'Add'}
            </button>
        </>
    );

    return (
        <CustomModal
            heading='Add Product'
            handleModal={handleModal}
            wide
            stickyFooterOnMobile
            footer={customFooter}
        >
            <input
                type="file"
                id="fileUpload"
                onChange={handleFileChange}
                style={{ display: "none" }}
                ref={uploadref}
                accept="image/*"
            />
            <label style={labelStyle}>Product Image</label><br />
            {!file ?
                <label
                    className='d-flex justify-content-center align-items-center'
                    htmlFor="fileUpload"
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                    style={{
                        backgroundColor: dragging ? 'rgba(54, 47, 216, 0.03)' : '#F3F3F3',
                        border: dragging ? '2px dashed #362FD8' : '2px dashed #E4E4E4',
                        borderRadius: '16px',
                        fontFamily: "Outfit",
                        width: "100%",
                        minHeight: "140px",
                        cursor: "pointer",
                        transition: 'all 0.2s ease',
                    }}>
                    <div className='d-flex flex-column justify-content-center align-items-center' style={{ padding: '12px' }}>
                        <Upload />
                        <span className='mt-1' style={{ fontSize: '15px', fontWeight: 500 }}>
                            {dragging ? 'Drop image here' : 'Choose photo'}
                        </span>
                        <span style={{ fontSize: '12px', color: '#aaa', marginTop: '4px' }}>
                            or drag and drop
                        </span>
                    </div>
                </label>
                :
                <div>
                    <div
                        style={{
                            minHeight: "140px",
                            cursor: "pointer",
                            borderRadius: '16px',
                            overflow: 'hidden',
                            border: '2px solid #E4E4E4',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: '#F9F9F9',
                        }}
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                        onClick={() => { uploadref.current.click() }}
                    >
                        <img style={{ maxHeight: '220px', maxWidth: '100%', objectFit: 'contain' }} src={URL.createObjectURL(file)} alt="" />
                    </div>
                    <div style={{ display: 'flex', gap: '10px', marginTop: '8px', flexWrap: 'wrap' }}>
                        <button
                            type='button'
                            onClick={() => uploadref.current.click()}
                            className='vsr-action-btn'
                            style={{ background: 'transparent', border: '1px solid #E0E0E0', color: '#362FD8', borderRadius: '8px', padding: '8px 14px', cursor: 'pointer', fontFamily: 'Outfit', fontWeight: 500, fontSize: '14px', minHeight: '40px' }}
                        >
                            Change photo
                        </button>
                        <button
                            type='button'
                            onClick={() => setFile(undefined)}
                            className='vsr-action-btn'
                            style={{ background: 'transparent', border: '1px solid #E0E0E0', color: '#666', borderRadius: '8px', padding: '8px 14px', cursor: 'pointer', fontFamily: 'Outfit', fontWeight: 500, fontSize: '14px', minHeight: '40px' }}
                        >
                            Remove
                        </button>
                    </div>
                </div>
            }

            <label style={labelStyle} htmlFor="" title="Display name shown to customers in the rewards catalog">Product Name</label><br />
            <div className=' text-right'>
                <input onChange={handleChange} name='name' value={data.name} placeholder='Enter here' style={inputStyle} type="text" maxLength={24} />
                <span style={{ color: '#828282', fontSize: '14px', fontWeight: 400, fontFamily: "Outfit" }}>{data.name.length}-24 character</span>
            </div>
            <label style={labelStyle} htmlFor="" title="Number of points a customer needs to redeem this product">Points Required</label><br />
            <div className=' text-right'>
                <input onChange={handleChange} name='pointsRequired' value={data.pointsRequired} placeholder='Enter here' style={inputStyle} type="text" maxLength={24} />
            </div>
            <div
                className='custom-control custom-control-alternative custom-checkbox'
                style={{ padding: 0, marginTop: '14px', marginBottom: '4px' }}
            >
                <input
                    className='checkboxInput'
                    id='addProductHasVariants'
                    type='checkbox'
                    checked={hasVariants}
                    onChange={(e) => {
                        setHasVariants(e.target.checked)
                        setVariantsError(null)
                    }}
                    style={{ marginRight: '8px' }}
                />
                <label
                    htmlFor='addProductHasVariants'
                    style={{ marginBottom: 0, fontWeight: 600, fontSize: '15px', fontFamily: 'Outfit', color: '#1C1C1C', cursor: 'pointer' }}
                >
                    This item has variants
                </label>
                <div style={{ marginTop: '4px', fontSize: '13px', color: '#828282', fontFamily: 'Outfit', paddingLeft: '24px' }}>
                    Use variants for size, color, flavor — anything where stock differs.
                </div>
            </div>

            {hasVariants ? (
                <VariantEditor variants={variants} onChange={setVariants} error={variantsError} />
            ) : (
                <>
                    <label style={labelStyle} htmlFor="" title="How many units are available for redemption">Stock Level </label><br />
                    <div className=' text-right'>
                        <input onChange={handleChange} name='stockLevel' value={data.stockLevel} placeholder='Enter here' style={inputStyle} type="text" maxLength={24} />
                    </div>
                </>
            )}
            <label style={{ ...labelStyle, marginTop: '14px' }} htmlFor="" title="Brief description of the reward product (max 120 characters)">Description</label><br />
            <div className=' text-right'>
                <textarea onChange={handleChange} name='description' value={data.description} placeholder='Enter here' maxLength={120} style={{
                    backgroundColor: '#F3F3F3',
                    border: 'none',
                    borderRadius: '8px',
                    fontFamily: "Outfit",
                    width: "100%",
                    padding: '12px 17px',
                    resize: "none",
                    minHeight: '88px',
                }} />
            </div>
        </CustomModal>
    )
}

export default AddProduct
